import { TICKET_ROLES } from "./articleRoles";

export const SUPPORT_ARTICLES = [
   {
      id: "support-tickets",
      category: "Getting help",
      title: "Contact support with a ticket",
      summary: "Report a problem or ask our team a question, and follow your tickets.",
      roles: TICKET_ROLES,
      body: `
Use a support ticket to report a problem or ask our team a question.

## Open a ticket

1. Click **Help** at the top of any page, then **Contact support**. You can also click your avatar and choose **Tickets**.
2. Click **Add ticket**.
3. Choose a **Ticket type**, write a short **Summary**, and fill in **Describe the problem in detail**.
4. Optionally, attach up to 3 files, such as screenshots (JPG, PNG, GIF, WEBP), PDF, Word or Excel files.
5. Click **Create ticket**. You'll see "Ticket created successfully!"

> **Tip:** Say which page you were on and what you clicked, and attach a screenshot. It helps our team answer faster.

## Find a ticket

Your tickets are listed under **Ticket history list**, with their subject, type, creation date and who submitted them.

- Use **Search...** or **Filter by type** to find a ticket.
- Click the arrow on a row to see the ticket's details and attachments.

## Delete tickets

If your role allows it, tick the tickets and click **Delete selected rows**, then confirm with **Yes, delete it**. Deleted tickets can't be restored.
`
   }
];
